<form [formGroup]="cpfForm">
    <div class="row">
        <div class="col-12 card-aling" style="text-align: center;">

            <mat-form-field style="width: 232px" appearance="standard" class="input-full-width">
                <mat-label>Digite o CPF</mat-label>
                <input matInput placeholder="Digite o CPF" mask="000.000.000-00" formControlName="cpf">
            </mat-form-field> 

            <button type="button" mat-flat-button color="primary"[disabled]="!this.cpfValid" (click)="openCaptacao()">Cadastrar</button>
        </div>       
    </div> 
</form>

